import React from "react";
import {
  Box,
  Container,
  FormField,
  RadioGroup,
  SpaceBetween,
} from "@amzn/awsui-components-console";

import {
  ATOZ_ESCALATION_EXCLUSIONS,
  ATOZ_ESCALATION_INTRO,
  ATOZ_ESCALATION_OPTIONS,
  ATOZ_ESCALATION_QUESTION,
  type AtozEscalationAnswer,
} from "./atozEscalation";

interface AtozEscalationQuestionProps {
  value: AtozEscalationAnswer | null;
  onChange: (answer: AtozEscalationAnswer) => void;
  /** Prefix for the test ids, so each pre-screen keeps its own namespace. */
  testIdPrefix: string;
}

/**
 * Asks a user who can file both AtoZ and IPL claims whether the claim meets an
 * exclusion that takes it out of the AtoZ program. Shared by both pre-screens.
 */
function AtozEscalationQuestion({
  value,
  onChange,
  testIdPrefix,
}: AtozEscalationQuestionProps): JSX.Element {
  return (
    <Container data-testid={`${testIdPrefix}-escalation-container`}>
      <SpaceBetween size="s" direction="vertical">
        <Box variant="p">{ATOZ_ESCALATION_INTRO}</Box>
        <FormField
          label={ATOZ_ESCALATION_QUESTION}
          data-testid={`${testIdPrefix}-escalation-form-field`}
        >
          <SpaceBetween size="s" direction="vertical">
            <ul data-testid={`${testIdPrefix}-escalation-exclusions`}>
              {ATOZ_ESCALATION_EXCLUSIONS.map(({ text, details }) => (
                <li key={text}>
                  {text}
                  {details && (
                    <ul>
                      {details.map((detail) => (
                        <li key={detail}>{detail}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <RadioGroup
              data-testid={`${testIdPrefix}-escalation-radio`}
              items={ATOZ_ESCALATION_OPTIONS}
              value={value}
              onChange={({ detail }) => onChange(detail.value as AtozEscalationAnswer)}
              ariaRequired
            />
          </SpaceBetween>
        </FormField>
      </SpaceBetween>
    </Container>
  );
}

export default React.memo(AtozEscalationQuestion);
